import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { EmptyLayerListContainer, EmptyLayerListIcon, EmptyLayerListTitle } from "../EmptyLayerList/styled";
import { getSearchIcon } from "./utils/getSearchIcon";
import { SearchMode } from "./types";

export const NothingFound: FC<{ searchMode: SearchMode }> = ({ searchMode }) => {
  const { t } = useTranslation("layerList");

  return (
    <EmptyLayerListContainer>
      <EmptyLayerListIcon kind={getSearchIcon(searchMode)} />
      <EmptyLayerListTitle style={{ opacity: 0.28, marginTop: "0.75rem" }}>{t("nothingFound")}</EmptyLayerListTitle>
    </EmptyLayerListContainer>
  );
};
